var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8172)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8172",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8172)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_8172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3329 24.9927C45.3329 36.2265 36.2265 45.333 24.9926 45.333C13.7587 45.333 4.65234 36.2265 4.65234 24.9927C4.65234 13.7589 13.7588 4.65234 24.9926 4.65234C36.2264 4.65234 45.3329 13.7589 45.3329 24.9927Z",
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.3623 25.3643C26.5721 25.3643 27.7547 25.0055 28.7606 24.3334C29.7664 23.6613 30.5504 22.706 31.0134 21.5883C31.4764 20.4706 31.5975 19.2408 31.3615 18.0543C31.1255 16.8677 30.5429 15.7778 29.6875 14.9224C28.832 14.067 27.7421 13.4844 26.5556 13.2484C25.3691 13.0124 24.1392 13.1335 23.0215 13.5965C21.9039 14.0594 20.9486 14.8434 20.2765 15.8493C19.6043 16.8552 19.2456 18.0378 19.2456 19.2476C19.2454 20.0509 19.4035 20.8464 19.7108 21.5886C20.0181 22.3308 20.4686 23.0052 21.0367 23.5732C21.6047 24.1412 22.2791 24.5918 23.0213 24.8991C23.7635 25.2064 24.559 25.3645 25.3623 25.3643ZM25.3623 28.4226C21.2794 28.4226 13.1289 30.4717 13.1289 34.5393V37.5977H37.5957V34.5393C37.5956 30.4717 29.4451 28.4226 25.3623 28.4226Z",
    fill: "#1F3A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.002 0.537109C38.4908 0.537109 49.4648 11.5111 49.4648 25C49.4648 38.4889 38.4908 49.4629 25.002 49.4629C11.5131 49.4629 0.539062 38.4889 0.539062 25C0.539062 11.5111 11.5131 0.537109 25.002 0.537109ZM25.002 48.584C38.0062 48.584 48.5859 38.0043 48.5859 25C48.5859 11.9957 38.0062 1.41602 25.002 1.41602C11.9977 1.41602 1.41797 11.9957 1.41797 25C1.41797 38.0043 11.9977 48.584 25.002 48.584Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_8172",
    x: -1.34766,
    y: 1.65234,
    width: 52.6797,
    height: 52.6797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_8172"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_8172",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.ea7f1bf2979f91ba8799ae00109508b4.svg";
export { ForwardRef as ReactComponent };